<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.13634 5.36664C7.42923 5.07375 7.9041 5.07375 8.197 5.36664L12.8637 10.0333C13.1566 10.3262 13.1566 10.8011 12.8637 11.094C12.5708 11.3869 12.0959 11.3869 11.803 11.094L7.66667 6.95763L3.53033 11.094C3.23744 11.3869 2.76256 11.3869 2.46967 11.094C2.17678 10.8011 2.17678 10.3262 2.46967 10.0333L7.13634 5.36664Z" fill="currentColor"/>
  </svg>
</template>
<script>
  export default {
    name: 'ChevronIcon',
  };
</script>
